const FinanceiroComponent = () => {
    return(
        <div>FinanceiroComponent</div>
    )
}
export default FinanceiroComponent;